(function () {
    const frequencyOptions = {
        never: 'Never',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
    };
    const savedSearches = {
        editBtns: document.querySelectorAll("[data-action-type='saved-search--edit']"),
        searchTerm: document.querySelector('.search-term'),
        editSaveSearchForm: document.querySelector('#editSaveSearchForm'),
        deleteBtns: document.querySelectorAll("[data-action-type='saved-search--remove']"),
        searchTab: document.querySelector('.tab__saved-search') ? document.querySelector('.tab__saved-search') : false,
        query: null,
        queryId: null,
        init() {
            savedSearches.control();
        },
        control: function () {
            savedSearches.editBtns.forEach(btn => {
                btn.addEventListener('click', function (evt) {
                    savedSearches.onEditBtn(evt, btn);
                });
            });

            savedSearches.editSaveSearchForm.addEventListener('submit', function (evt) {
                savedSearches.onSubmit();
            });

            savedSearches.deleteBtns.forEach(btn => {
                btn.addEventListener('click', function (evt) {
                    savedSearches.onDeleteBtn(evt, btn);
                });
            });
        },
        onEditBtn(evt, target) {
            evt.preventDefault();
            const editQueryStr = target.href.slice(target.href.indexOf('?'));
            // extract the saved search data (queryId, queryName, frequency) from the edit query string
            savedSearches.query = new URLSearchParams(editQueryStr);
            savedSearches.queryId = savedSearches.query.get('queryId');
            const queryName = savedSearches.query.get('queryName');
            const frequency = savedSearches.query.get('frequency').toLowerCase();
            // fill the saved search modal inputs (search name, and frequency) with the selected saved search values
            savedSearches.searchTerm.value = queryName;
            const frequencyInput = document.querySelector(`input[value='${frequencyOptions[frequency]}']`);
            frequencyInput.checked = true;
            // focus search name input
            savedSearches.setFocus(queryName);
        },
        onSubmit() {
            const searchTerm = savedSearches.searchTerm.value;
            const frequency = document.querySelector("input[name='alertme']:checked").value;
            $.ajax({
                type: 'GET',
                url: `/action/doSaveSearch?saveSearchName=${searchTerm}&queryId=${savedSearches.queryId}&alertme=${frequency}&perform=save`,
            });
            if (savedSearches.searchTab) {
                let tabId = savedSearches.searchTab.querySelector('.tab__nav__item__link')
                    ? savedSearches.searchTab.querySelector('.tab__nav__item__link').getAttribute('aria-controls')
                    : '';
                savedSearches.editSaveSearchForm.action = `?activeTab=${tabId}`;
            }
        },
        setFocus(queryName) {
            setTimeout(() => {
                // set the typing cursor at the end of the search name value
                const end = queryName.length;
                savedSearches.searchTerm.setSelectionRange(end, end);
                savedSearches.searchTerm.focus();
            }, 100);
        },
        onDeleteBtn(evt, target) {
            if (savedSearches.searchTab) {
                evt.preventDefault();
                $.ajax({
                    type: 'GET',
                    url: target.href,
                });
                let tabId = savedSearches.searchTab.querySelector('.tab__nav__item__link')
                    ? savedSearches.searchTab.querySelector('.tab__nav__item__link').getAttribute('aria-controls')
                    : '';
                window.location = `?activeTab=${tabId}`;
            }
        },
    };
    UX.savedSearches = savedSearches;
})();
